var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97 11.47a.75.75 0 0 1 1.06 0l3.22 3.22V2.195c0-.384.336-.696.75-.696s.75.312.75.696V14.69l3.22-3.22a.75.75 0 1 1 1.06 1.061l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 0-1.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.5a.75.75 0 0 0-.75.75V21a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 21v-3.75a.75.75 0 0 0-1.5 0V21h-15v-3.75a.75.75 0 0 0-.75-.75Z"
  })));
};
export default SvgDownload;